import COLOR from "../../../constants/colors";

const styles = {
  editImageBtn: {
    position: "absolute",
    right: "5%",
    bottom: "30%",
  },
  avatar: {
    background: COLOR.white,
  },
  editAvatarBtn: {
    position: "absolute",
    right: "5%",
    bottom: "0%",
  },
  displayName: {
    // position: "absolute",
    // top: "22%",
    // left: "50%",
    // fontWeight: "bold",
  },
};

export default styles;
